import { observer } from "mobx-react-lite";
import React from "react";

import Svg from "../../../components/svg/Svg";
import { Email, Address, TelFax } from "../../../components/svg/svgImageList";
import { TermsAndConditions } from "../../../components/terms-and-conditions/TermsAndConditions";
import { translationService } from "../../../services/translation/TranslationService";
import "./composition.scss";
import { Box, Grid } from "@mui/material";

interface StaticInfoProps {
  svg: React.FunctionComponent;
  descriptionKey: string;
}

export const HelpContact = observer(() => {
  return (
    <div  className="help-contact-container">
      <div style={{ textAlign: 'center' }} className="contact-title">{translationService.translate("HelpPage.contact.title")}</div>
      <div>
        <div style={{ textAlign: 'center' }} className="contact-text">{translationService.translate("HelpPage.contact.text")}</div>
        <TermsAndConditions />
      </div>
      <Grid container className="centered contact-details"  >  
        <Grid item xs={6} lg= {4}className="centered">
            <StaticInfo svg={Address} descriptionKey="general.contact.address" />
        </Grid>
        <Grid item xs={6} lg= {4}className="centered">
            <StaticInfo svg={Address} descriptionKey="general.contact.address2" />
        </Grid>
        <Grid item xs={6} lg= {4} className="centered">
            <StaticInfo svg={TelFax} descriptionKey="general.contact.telFax" />
        </Grid>
      </Grid>
    </div>
  );
});

const StaticInfo = (props: StaticInfoProps) => {
  const { svg, descriptionKey } = props;
  return (
    <div className="static-info-item" style={{marginRight: 20}}>
      <Svg svg={svg} width={50} height={50} />
      <pre>{translationService.translate(descriptionKey)}</pre>
    </div>
  );
};
